var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"currency-count",class:{ 'currency-count--dark': _vm.isDark }},[_c('span',{staticClass:"currency-count__emoji"},[_vm._v("🥕")]),_c('span',{staticClass:"currency-count__num"},[_vm._v(_vm._s((_vm.balance || 0).toLocaleString()))])])
}
var staticRenderFns = []

export { render, staticRenderFns }